import type { Action } from 'redux';

export const CLEAR_JOB_DETAILS = 'FILE_INGESTOR_CLEAR_JOB_DETAILS';

export const clearJobDetails = (): ClearJobDetailsAction => {
  return {
    type: CLEAR_JOB_DETAILS,
  };
};

export type ClearJobDetailsAction = Action<typeof CLEAR_JOB_DETAILS>;
